export const BRAIN_CATEGORIES = [
  { value: "product_context", label: "Product promises" },
  { value: "auth_security", label: "Roles and permissions" },
  { value: "data_model", label: "Data and privacy" },
  { value: "integration", label: "Integrations" },
  { value: "deployment", label: "Operational rules" },
  { value: "architecture", label: "Technical guardrails" },
  { value: "do_not_touch", label: "Technical guardrails" },
  { value: "test_commands", label: "Technical guardrails" },
  { value: "style_conventions", label: "Technical guardrails" },
  { value: "review_checklist", label: "Operational rules" },
  { value: "freelancer_guidance", label: "Terminology" },
  { value: "other", label: "Product promises" },
];

export const BRAIN_ADD_CATEGORIES = [
  { value: "product_context", label: "Product promises" },
  { value: "freelancer_guidance", label: "Terminology" },
  { value: "auth_security", label: "Roles and permissions" },
  { value: "data_model", label: "Data and privacy" },
  { value: "integration", label: "Integrations" },
  { value: "deployment", label: "Operational rules" },
  { value: "architecture", label: "Technical guardrails" },
];

export function brainCategoryLabel(value) {
  return BRAIN_CATEGORIES.find((item) => item.value === value)?.label || "Product promises";
}

export function brainState(item) {
  if (item?.conflictIds?.length) return "Conflicted";
  if (item?.status === "outdated") return "Outdated";
  if (item?.status === "pending") return "Inferred";
  return "Confirmed";
}

const SOURCE_GROUPS = [
  ["Product documentation", (path) => /readme|\.md$|^docs\//i.test(path)],
  ["Tests and contracts", (path) => /\.(test|spec)\.|schema|openapi|contract/i.test(path)],
  ["Permissions and billing", (path) => /permission|role|billing|entitlement|checkout/i.test(path)],
  ["Review decisions", (path) => path === "review" || path === "manual"],
];

export function groupBrainSources(suggestions = []) {
  const groups = new Map();
  suggestions.forEach((suggestion) => {
    const sources = suggestion.sources?.length
      ? suggestion.sources
      : [{ path: suggestion.origin === "manual" ? "manual" : (suggestion.pathScope?.[0] || "review"), sha: suggestion.sourceSha }];
    sources.forEach((source) => {
      const path = String(source.path || "review");
      const match = SOURCE_GROUPS.find(([, test]) => test(path));
      const name = match ? match[0] : "Product implementation";
      const group = groups.get(name) || { name, count: 0, sha: "", seen: "" };
      group.count += 1;
      group.sha = source.sha || group.sha;
      group.seen = suggestion.lastSeenAt || suggestion.updatedAt || group.seen;
      groups.set(name, group);
    });
  });
  return [...groups.values()];
}

export const FUTURE_SOURCES = [
  { name: "Notion", state: "Not available yet" },
  { name: "Linear", state: "Not available yet" },
  { name: "Google Drive", state: "Not available yet" },
  { name: "Meeting transcripts", state: "Not available yet" },
];
